import sessionConstants from '../../constants/SessionConstants';
import UIConstants from '../../constants/UIConstants';
import sessionReader from '../../store/readHelpers/SessionReader';
import a11yIIBScreenReaderService, { A11yForIIBScreenReaderIteration } from '../a11yIIBScreenReaderService';
import marketplacePropertiesService from '../MarketplacePropertiesService';

export const classNameTypes = {
    SCROLL: 'gap-multi-interaction-scroll',
    HORIZONTAL_SCROLL: 'gap-multi-interaction-horizontal-scroll',
    VISIBLE: 'gap-multi-interaction-visible',
};

const GapMatchInteractionServices = {
    getMultiInteractionClass(tokenPosition, zoomFactor, shouldAutoSizeTokens) {
        if (!marketplacePropertiesService.isEnableTwoInlineGapMatchAreas()) return '';
        const isReversedPosition = ['bottom', 'right', 'rightWithSplitPreview'].includes(tokenPosition);
        const isNotSmallTextSize = zoomFactor !== UIConstants.ZOOM_FACTOR.SMALL;
        const printStyle = sessionReader.getPrintParam('printStyle');
        if (printStyle === sessionConstants.PRINT_STYLE_STANDARD) return classNameTypes.VISIBLE;
        if (sessionReader.isPrintStylePaperBased()) return classNameTypes.VISIBLE;
        if (isReversedPosition && shouldAutoSizeTokens) return classNameTypes.HORIZONTAL_SCROLL;
        return isReversedPosition && isNotSmallTextSize ? classNameTypes.SCROLL : classNameTypes.VISIBLE;
    },
    getAutoSizeTokenStyles(gapWidth, shouldAutoSizeTokens) {
        const hasMeasuredGapWidth = Number.isFinite(gapWidth) && gapWidth > 0;
        const fallbackWidth = (0.3 * window.innerWidth) + 3;
        const effectiveWidth = hasMeasuredGapWidth ? gapWidth + 3 : fallbackWidth;

        if (shouldAutoSizeTokens) {
            return {
                width: `${effectiveWidth}px`,
                maxWidth: '100%',
            };
        }

        return {
            maxWidth: `${effectiveWidth}px`,
        };
    },
    getImageTokenDimensions(gapChoiceModel) {
        const imageHeight = gapChoiceModel?.dimensions?.height;
        const imageWidth = gapChoiceModel?.dimensions?.width;
        return { imageHeight, imageWidth };
    },
    isA11ySupportedForV4AndAbove() {
        return a11yIIBScreenReaderService.isA11yIterationForIIBScreenReaderSupported(A11yForIIBScreenReaderIteration.v4);
    },
    getInteractionBody(interactionBody) {
        const body = interactionBody || '';
        if (!this.isA11ySupportedForV4AndAbove()) {
            return body;
        }
        return body.replace(/<blockquote(?=[ >])/g, '<blockquote role="presentation"');
    },
};

export default GapMatchInteractionServices;
